import { useTranslation } from '@exam-room/translations';

import { Modal, type ModalProps } from '../../../components';

import PDFViewer from './PDFViewer';
interface DocumentModalProps extends Omit<ModalProps, 'children'> {
  url: string;
}
export default function DocumentModal(props: DocumentModalProps) {
  const { t } = useTranslation();
  const { open, onClose, url } = props;
  return (
    <Modal open={open} onClose={onClose} className='h-fit w-full max-w-[1280px] p-6'>
      <div className='flex size-full flex-col gap-6'>
        <h3 className='font-semibold'>{t('examTools.referenceDocs')}</h3>
        <hr className='border-border-divider' />
        <div className='flex-1'>
          <PDFViewer url={url} className='h-[720px]' />
        </div>
      </div>
    </Modal>
  );
}
